import { Component, EventEmitter, Input, Output, OnDestroy } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { CommonDataService } from "../../common-data.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-directory-view",
  templateUrl: "./directory-view.component.html",
  styleUrls: ["./directory-view.component.scss"],
})
export class DirectoryViewComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  // Inputs from parent (previously accessed via injector)
  @Input() teams: any[] = [];
  @Input() orgId: string = '';
  @Input() teamsPerPage: number = 20;
  @Input() memViewTeam: any;
  @Input() teamMemberCurrentPg: number = 1;
  @Input() demoRosterId: string = '';
  @Input() CommonDataService: CommonDataService;

  // Outputs to parent
  @Output() teamsChange = new EventEmitter<any[]>();
  @Output() openSideBarEvent = new EventEmitter<any>();
  @Output() selectTeamForGraph = new EventEmitter<any>();
  @Output() participantViewEvent = new EventEmitter<{from: string, team: any, member?: any}>();
  @Output() openCloseTeamPopupEvent = new EventEmitter<{open: boolean, id?: string, name?: string}>();
  @Output() deleteTeamEvent = new EventEmitter<any>();
  @Output() removeRosterMemEvent = new EventEmitter<{item: any, index: number, type: string, teamIndex: number}>();
  @Output() viewChangeEvent = new EventEmitter<string>();
  @Output() goToProfile = new EventEmitter<any>();
  @Output() removeTeamMemberEvent = new EventEmitter<any>();
  @Output() addToTeamEvent = new EventEmitter<any>();
  @Output() makeTeamLeadEvent = new EventEmitter<{member: any, roleId: number}>();
  @Output() refreshTeamsEvent = new EventEmitter<void>();

  loader: boolean = false;
  view: string = "dirView"; // dirView or memView
  currentPg = 1;
  totalMemberView: number = 20;
  sortBy: string = '';
  sortType: string = "asc";

  constructor(
    private commonService: CommonDataService
  ) {
  }

  openSideBar(team) {
    this.view = "memView";
    this.currentPg = 1;
    this.loader = true;
    this.openSideBarEvent.emit(team);
    if (
      team?.memberships_count > 20 &&
      team?.memberships?.length <= 20
    ) {
      setTimeout(() => {
        this.loader = false;
      }, 1000);
    } else {
      this.loader = false;
    }
  }

  getSortedData(sortBy: string, sortType: string) {
    this.sortBy = sortBy;
    this.sortType = sortType;
    if (this.view == "dirView") {
      let sortData: any = this.commonService.sortData(
        `${environment.profileURL}/api/v1/organizations/` +
          this.orgId +
          `/teams.json?page=${this.currentPg}&per_page=${this.teamsPerPage}&`,
        sortBy,
        sortType
      );
      sortData.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.teams = res?.teams;
        this.teamsChange.emit(this.teams);
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      });
    }
  }

  updateCurrentPg(pg) {
    this.currentPg = pg;
    if (this.view == "memView") {
      let memberResult = this.commonService.getPageData(
        `${environment.profileURL}/api/v1/teams/` +
          this.memViewTeam.id +
          `/memberships.json`,
        pg,
        this.totalMemberView
      );
      memberResult.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.memViewTeam.memberships = res?.memberships;
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      });
    } else if (this.view == "dirView") {
      let memberResult = this.commonService.getPageData(
        `${environment.profileURL}/api/v1/organizations/` +
          this.orgId +
          `/teams.json`,
        pg,
        this.totalMemberView
      );
      memberResult.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.teams = res?.teams;
        this.teamsChange.emit(this.teams);
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      });
    }
  }

  onViewBack() {
    this.view = "dirView";
    this.viewChangeEvent.emit("dirView");
    this.refreshTeamsEvent.emit();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
